import { useState } from "react";
import Modal from "../shared/Modal";
import { Button } from "../../ds2/components";
import "./TemplateGeneratorCollectEmailModal.css";
import { validateEmail } from "../uiHelpers";
import { Check } from "lucide-react";

type TemplateGeneratorCollectEmailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
};

const TemplateGeneratorCollectEmailModal = ({isOpen, onClose, onSubmit}: TemplateGeneratorCollectEmailModalProps) => {

    const [email, setEmail] = useState<string>("");
    
    if (!isOpen) {
        return null;
    }

    return (
        <>
            <Modal
                isOpen={isOpen}
                style={null}
                onClose={onClose}
                canClose={true}
                allowClickout={true}
            >
                <div id="template-generator-email-collect">
                    <div className="template-generator-email-collect-title">
                        Download Your Template
                    </div>
                    <div>
                        Enter your email and instantly download your filled out template!
                    </div>
                    
                    <div className="template-generator-email-collect-email">
                        <input 
                            type="text"
                            placeholder="Enter your email"
                            value={email}
                            className="template-generator-email-collect-email-input"
                            onChange={(e) => setEmail(e.target.value.trim())}
                        />
                        <div className="template-generator-email-input-ok">
                            <Check size={12} color={validateEmail(email) ? "green" : "red"} />
                        </div>
                    </div>
                
                <div className="template-generator-email-collectt-footer">
                    <div className="template-generator-email-collect-buttons">
                        <button
                            className="template-generator-email-collect-button"
                            onClick={()=>onSubmit(email)}
                            disabled={!validateEmail(email)}
                        >
                            Send me My Template!
                        </button>
                    </div>
                </div>
                </div>
            </Modal>
        </>
    );
};

export default TemplateGeneratorCollectEmailModal;
